"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Alert = {
    parts: ['container'],
    baseStyle: {
        container: {
            fontSize: 'md',
        },
    },
};
exports.default = Alert;
